import React from 'react';
import {Icon} from '@iconify/react';
import {useNavigate} from 'react-router-dom';
import {useAuth} from '../../context/AuthContext';
import './PremiumHowToPlay.css';

const PremiumHowToPlay=()=>{

	const navigate=useNavigate();
	const {isPremium,loading}=useAuth();

	// ✅ Never return null — always render something
	if(loading){
		return(
			<section className="phtp">
				<div className="phtp__inner">
					<p style={{color:'#9ca3af'}}>Loading guide…</p>
				</div>
			</section>
		);
	}

	// 🔒 Premium-only gate (no silent redirect — show a clear screen)
	if(!isPremium){
		return(
			<section className="phtp">
				<div className="phtp__inner">
					<div style={{
						border:'1px solid rgba(148,163,184,0.35)',
						background:'rgba(15,23,42,0.96)',
						borderRadius:'16px',
						padding:'16px'
					}}>
						<p style={{margin:'0 0 8px',color:'#a5b4fc',textTransform:'uppercase',letterSpacing:'0.12em',fontSize:'12px'}}>
							Premium guide
						</p>
						<h2 style={{margin:'0 0 8px'}}>This guide is Premium-only</h2>
						<p style={{margin:'0 0 12px',color:'#9ca3af'}}>
							Upgrade to Premium to unlock the full “How to Play Premium Matches” guide.
						</p>

						<button
							type="button"
							className="phtp__btn phtp__btn--primary"
							onClick={()=>navigate('/pricing')}
						>
							View Premium plans
						</button>
					</div>
				</div>
			</section>
		);
	}

	// ✅ Premium content
	return(
		<section className="phtp">
			<div className="phtp__inner">

				<header className="phtp__header">
					<p className="phtp__eyebrow">
						<Icon icon="solar:shield-check-linear" />
						Premium guide
					</p>
					<h1 className="phtp__title">How to play Premium Matches</h1>
					<p className="phtp__subtitle">
						Premium Matches are designed for long-term growth — but only if you use the system correctly.
					</p>
				</header>

				<div className="phtp__warning">
					<Icon icon="solar:danger-triangle-linear" className="phtp__warning-icon" />
					<div>
						<p className="phtp__warning-title">
							Premium Matches must be played as SINGLES
						</p>
						<p className="phtp__warning-text">
							Do <strong>not</strong> combine Premium Matches into accas. One missed game can wipe your entire ticket.
							Single bets protect your bankroll and reduce total-loss risk.
						</p>
					</div>
				</div>

				<div className="phtp__card">
					<h2 className="phtp__card-title">Core rules</h2>
					<ul className="phtp__rules">
						<li>Each Premium Match = one single bet</li>
						<li>Never chase losses</li>
						<li>Decide stake sizes before the day starts</li>
						<li>Stop after your planned matches — no revenge bets</li>
					</ul>
				</div>

				<div className="phtp__card">
					<h2 className="phtp__card-title">Simple bankroll table</h2>

					<div className="phtp__table-wrap">
						<table className="phtp__table">
							<thead>
								<tr>
									<th>Total bankroll</th>
									<th>Matches/day</th>
									<th>Stake per match</th>
									<th>Total daily risk</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>$100</td>
									<td>5</td>
									<td>$2</td>
									<td>$10</td>
								</tr>
								<tr>
									<td>$500</td>
									<td>5</td>
									<td>$10</td>
									<td>$50</td>
								</tr>
								<tr>
									<td>$1,000</td>
									<td>5</td>
									<td>$20</td>
									<td>$100</td>
								</tr>
								<tr>
									<td>$1,000</td>
									<td>3</td>
									<td>$20</td>
									<td>$60</td>
								</tr>
							</tbody>
						</table>
					</div>

					<p className="phtp__table-note">
						Keep daily risk small enough to survive bad runs. Consistency beats jackpots.
					</p>
				</div>

				<div className="phtp__card phtp__card--hr">
					<h2 className="phtp__card-title">HR/HR (High Risk / High Reward)</h2>
					<p className="phtp__text">
						HR/HR picks are optional. Use tiny stakes only (0.25–0.5% of bankroll).
					</p>
				</div>

				<div className="phtp__actions">
					<button
						type="button"
						className="phtp__btn phtp__btn--primary"
						onClick={()=>navigate('/football')}
					>
						<Icon icon="solar:soccer-linear" />
						Back to Premium Matches
					</button>
				</div>

			</div>
		</section>
	);
};

export default PremiumHowToPlay;
